const muiTheme = {};
// const muiTheme = {
//   light: {
//     themeName: 'light',
//     typography: {
//       useNextVariants: true,
//       fontFamily: [
//         'Roboto',
//         'Lato',
//         '"Helvetica Neue"',
//         '-apple-system',
//         'BlinkMacSystemFont',
//         '"Segoe UI"',
//         'Arial',
//         'sans-serif',
//         '"Apple Color Emoji"',
//         '"Segoe UI Emoji"',
//         '"Segoe UI Symbol"',
//       ].join(','),
//     },
//     mixins: {
//       toolbar: {
//         minHeight: 0,
//       },
//     },
//     palette: {
//       type: 'light',
//       ...colors,
//     },
//   },
//   dark: {
//     themeName: 'dark',
//     typography: {
//       useNextVariants: true,
//       fontFamily: [
//         'Roboto',
//         'Lato',
//         '"Helvetica Neue"',
//         '-apple-system',
//         'BlinkMacSystemFont',
//         '"Segoe UI"',
//         'Arial',
//         'sans-serif',
//         '"Apple Color Emoji"',
//         '"Segoe UI Emoji"',
//         '"Segoe UI Symbol"',
//       ].join(','),
//     },
//     mixins: {
//       toolbar: {
//         minHeight: 0,
//       },
//     },
//     palette: {
//       type: 'dark',
//       ...colors,
//     },
//   },
// };

/**
 * Object that contains all the overrides to the default Mui theme
 */
export const overridesMuiTheme = {
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    fontSize: 10,
  },
  overrides: {},
  breakpoints: {
    values: {
      xs: 0,
      sm: 720, //600
      md: 1024, //960
      lg: 1280,
      xl: 2160, //190
    },
  },
};

export default muiTheme;
